import React from "react";
import {useTranslation} from 'react-i18next';



const LenderHeroSection = () =>{
    const {t}=useTranslation('lenderPage');
    return(
        <section className='section-container'> 
            <div className='lender-hero-section'>
                <div className="left-lender-hero-section">
                    <div className="left-lender-hero-section-content">
                    {t('left-lender-hero-section.line1')} <span>{t('left-lender-hero-section.line2')}</span> {t('left-lender-hero-section.line3')}
                    <p>{t('left-lender-hero-section.line4')}</p>
                </div> 
                </div>
                        
                <div className="right-lender-hero-section">
                <div className="right-lender-hero-section-content">
                    <img src="/images/bankIMG.png" alt="retailInvoice" />
                </div>
                </div> 
            </div>    
        </section>
    )
}

export default LenderHeroSection;